import { Interaction, PointElement } from 'chart.js';
import { getRelativePosition } from 'chart.js/helpers';

export default function (chart, e, options) {
  const position = getRelativePosition(e, chart);
  const items = [];
  for (var datasetIndex = 0; datasetIndex < chart.data.datasets.length; datasetIndex++) {
		// check for interpolate setting
		const { interpolate = true, stepped = false } = chart.data.datasets[datasetIndex];
		if (!interpolate) continue

		const meta = chart.getDatasetMeta(datasetIndex);
		// do not interpolate hidden charts
		if (meta.hidden) continue;

		const xScale = chart.scales[meta.xAxisID];
		const yScale = chart.scales[meta.yAxisID];

		const xValue = xScale.getValueForPixel(position.x);

		if (xValue > xScale.max || xValue < xScale.min) continue;

		const { data = [] } = chart.data.datasets[datasetIndex];

		const index = data.findIndex((o) => o.x >= xValue);
		if (index === -1) continue;

		// linear interpolate value
		const prev = data[index - 1] || { y: null };
		const next = data[index] || { y: null };
		const hasValue = prev.y !== null && next.y !== null;

    let interpolatedValue;
		if (stepped && prev) {
			interpolatedValue = prev.y;
		} else if (hasValue) {
			const prevTime = prev.x;
      const nextTime = next.x;
			const slope = (next.y - prev.y) / (nextTime - prevTime);
			interpolatedValue = prev.y + (xValue - prevTime) * slope;
		} 

		if (isNaN(interpolatedValue)) continue;

		const yPosition = yScale.getPixelForValue(interpolatedValue);

		// do not interpolate values outside of the axis limits
		if (isNaN(yPosition)) continue;

		// create a 'fake' event point
		const fakePoint = new PointElement({
			hasValue: () => true,
			tooltipPosition: () => this._model,
			_model: {x: e.x, y: yPosition},
			skip: false,
			stop: false,
			x: xValue,
			y: interpolatedValue,
		});

		items.push({ datasetIndex: datasetIndex, element: fakePoint, index: 0 });
	}


	// add other, not interpolated, items
	const xItems = Interaction.modes.x(chart, e, options);
	for (let index = 0; index < xItems.length; index +=1 ) {
		const item = xItems[index];
		const { interpolate = true, distanceToPointMax = 10 } = chart.data.datasets[item.datasetIndex];
		// skip if interpolate = true
		if (interpolate) continue;

		const { element: { x: xValue } = {} } = item;
		const foundIndex = items.findIndex(({ datasetIndex }) => datasetIndex === item.datasetIndex);
		const distanceToPoint = Math.abs(position.x - xValue);

		if (distanceToPoint > distanceToPointMax) continue;

		const datapoint = { ...item, distanceToPoint };
		if (!items[foundIndex]) {
			items.push(datapoint);
		} else if (items[foundIndex].distanceToPoint > distanceToPoint) {
			items.splice(foundIndex, 1, datapoint);
		}
  }
  
  return items.sort((a, b) => a.datasetIndex - b.datasetIndex);
};
